<template>
  <div>
    <TeSetPythonAiCover :pack="pack" />

    <TeCommonPagenav>
      <template #coursename>
        Python＋AIセット
      </template>
      <template #menu>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#about'"
            @click.prevent="scrollTo('about')"
          >
            概要
          </a>
        </li>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#price'"
            @click.prevent="scrollTo('price')"
          >
            料金
          </a>
        </li>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#flow'"
            @click.prevent="scrollTo('flow')"
          >
            受講の流れ
          </a>
        </li>
        <!-- 251202導線削除 -->
        <!-- <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#faq'"
            @click.prevent="scrollTo('faq')"
          >
            FAQ
          </a>
        </li> -->
      </template>
    </TeCommonPagenav>

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />
    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />
    <TeCommonBannerCampaign
      :course-name-path="packScreenName"
      :current-promotion="currentPromotion"
    />

    <!-- About -->
    <TeSetAbout>
      <template #title>
        【セット割】Python＋AIセットについて
      </template>
      <template #text>
        Pythonの基礎から機械学習・ディープラーニングまで学べるお得なセット。
        <br>
        PythonコースとAIコースを合わせて受講でき、
        <br>
        それぞれ1コースずつ受講した場合に比べ
        <strong class="text-co-danger-500">社会人プランで60,000円もお得に！</strong>
        <br>
        現役のエンジニアのパーソナルメンターが徹底サポートいたします。
      </template>
    </TeSetAbout>


    <section
      id="target"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 py-20 md:px-40 lg:px-4">
        <h2 class="co-display-7 mb-[3.25rem] text-center">
          こんな方にオススメです
        </h2>
        <div class="grid grid-cols-1 gap-y-10 lg:grid-cols-2 lg:gap-x-20">
          <TeSetTarget>
            <template #icon>
              <FontAwesomeIcon
                :icon="faHeadSideGear"
                class="fa-fw size-10"
              />
            </template>
            <template #catch>
              人工知能を基礎から<br class="sm:hidden">実践的に理解したい方
            </template>
            <template #discription>
              人工知能やディープラーニングに代表される機械学習を実際に体験しながら理解できます。
            </template>
          </TeSetTarget>
          <TeSetTarget>
            <template #icon>
              <FontAwesomeIcon
                :icon="faKeyboard"
                class="fa-fw inline size-10"
              />
            </template>
            <template #catch>
              機械学習ライブラリを使い<br class="sm:hidden">実装を行いたい方
            </template>
            <template #discription>
              scikit-learnやKerasといった機械学習ライブラリを使い、画像認識や評判分析、レコメンデーションなどを実装します。
            </template>
          </TeSetTarget>
          <TeSetTarget>
            <template #icon>
              <FontAwesomeIcon
                :icon="faSuitcase"
                class="fa-fw inline size-10"
              />
            </template>
            <template #catch>
              機械学習を学び<br class="sm:hidden">エンジニアとして活躍したい方
            </template>
            <template #discription>
              忙しい社会人の方でも、平日の夜、休日を使って学習することで働きながらでもジョブチェンジに挑戦することが可能です。
            </template>
          </TeSetTarget>
          <TeSetTarget>
            <template #icon>
              <FontAwesomeIcon
                :icon="faClockNine"
                class="fa-fw inline size-10"
              />
            </template>
            <template #catch>
              時間と場所にとらわれない<br class="sm:hidden">働き方をしたい方
            </template>
            <template #discription>
              手に職をつけることで、クラウドソーシングなどを利用し在宅でも深夜の時間帯でも、自由な働き方を実現できます。
            </template>
          </TeSetTarget>
        </div>
      </div>
    </section>

    <TeCommonDemographics />

    <!-- 学習内容1 -->
    <TeSetOutputLeftPython />

    <!-- 学習内容2 -->
    <TeSetOutputRigthtAi />

    <section
      id="skill"
      class="co-bg-striped text-center"
    >
      <div class="co-container-md px-4 py-20">
        <h2 class="co-heading-2-caption">
          身につくスキル
        </h2>
        <p class="co-display-12 mb-[3.25rem] text-left md:text-center">
          Pythonの基礎からAIの構築に必要な<br class="hidden md:block">機械学習・ディープラーニングまでまとめて学べます。
        </p>
        <div class="grid grid-cols-1 gap-y-12 sm:grid-cols-2 sm:gap-x-8 lg:grid-cols-3">
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-python.png"
                alt="Python"
              >
            </template>
            <template #name>
              Python
            </template>
            <template #discription>
              機械学習でよく使われる言語
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-machine-learning.png"
                alt="機械学習"
              >
            </template>
            <template #name>
              機械学習
            </template>
            <template #discription>
              AIを構築する際の根幹となる技術の1つ
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-pandas.png"
                alt="Pandas"
              >
            </template>
            <template #name>
              Pandas
            </template>
            <template #discription>
              データの集計・分析を行うライブラリ
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-scikit-learn.png"
                alt="scikit-learn"
              >
            </template>
            <template #name>
              scikit-learn
            </template>
            <template #discription>
              回帰分析やクラスタリングなどを行うライブラリ
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-keras.png"
                alt="Keras"
              >
            </template>
            <template #name>
              Keras
            </template>
            <template #discription>
              画像やテキストなどの分析を行うライブラリ
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-tensor-flow.png"
                alt="TensorFlow"
              >
            </template>
            <template #name>
              TensorFlow
            </template>
            <template #discription>
              画像認識や音声認識技術を行うライブラリ
            </template>
          </TeSetSkill>
        </div>
      </div>
    </section>

    <TeCommonComparisonAiDatascience>
      <template #course>
        データサイエンス
      </template>
      <template #link>
        Python+データサイエンスセットを
        <a :href="'/set/python-datascience'">
          詳しく見る
        </a>
      </template>
    </TeCommonComparisonAiDatascience>

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-first" /> -->

    <!-- 挫折させないパーソナルメンターサポート -->
    <section
      id="mentor-support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pt-20">
        <h2 class="co-heading-2-caption">
          挫折させない<span class="block md:inline">パーソナルメンターサポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          学習時の「わからない」「続かない」を解消し、挫折をなくします。
          <br class="hidden md:block">
          実務で培った技術とノウハウで受講生一人ひとりをサポートします。
        </h3>
        <div class="flex flex-col justify-center gap-x-8 sm:px-36 lg:flex-row lg:px-0">
          <TeCommonMentorSupportMentoring />

          <TeCommonMentorSupportChatSupport>
            <template #title>
              毎日15時〜23時の
            </template>
            <template #lead>
              メンターが毎日8時間常時オンラインで待機してるので疑問点を聞けばチャットですぐに回答がもらえます。
            </template>
          </TeCommonMentorSupportChatSupport>

          <TeCommonMentorSupportIssueReview />
        </div>
      </div>

      <TeCommonMentorSupportMentor>
        <template #mentorImage1>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-ota.jpg"
            alt="Kazuki Ota"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName1>
          Kazuki
          <br>
          Ota
        </template>
        <template #mentorProfile1>
          システムエンジニア歴約20年、プログラミング歴約35年。プログラミングの守備範囲はフロントエンド、サーバサイド、Android開発、機械学習と広く、また普段はシステム開発プロジェクトの管理や後輩の指導を行っています。
        </template>
        <template #mentorMessage1>
          プログラミングが出来るようになると世界が広がります！受講生様に寄り添い、楽しく学んで頂けるようサポートさせて頂きます。
        </template>
        <template #mentorImage2>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-saitoh.jpg"
            alt="Hitoshi Saitoh"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName2>
          Hitoshi
          <br>
          Saitoh
        </template>
        <template #mentorProfile2>
          国立研究開発法人の研究員として業務に従事。データサイエンティストとして、患者様の遺伝子配列データを用いた解析に日々邁進しております。技術の移り変わりに遅れを取らないよう、情報のアップデートが欠かせませんが、やりがいをもって取り組んでいます。
        </template>
        <template #mentorMessage2>
          プログラミングの学習は独学で行い、業務を通じて数多くの挑戦と挫折を経験しました。その経験を活かし、皆様が学習に取り組む際に寄り添い、心強いサポートを提供できればと考えております。一緒に成長していけることを心より楽しみにしております。
        </template>
      </TeCommonMentorSupportMentor>

      <TeCommonMentorSupportReason />
    </section>

    <!-- 受講スケジュールのイメージ -->
    <TeSetStudySchedule
      course-bg-one="#3e7baf"
      course-bg-two="#00bfd0"
    >
      <template #heading3>
        Pythonコースで基礎を習得してからAIコースをご受講ください。
      </template>
      <template #courseIcon1>
        <FontAwesomeIcon
          :icon="faPython"
          class="fa-fw co-display-10 size-5 pr-1"
        />
      </template>
      <template #courseIcon2>
        <FontAwesomeIcon
          :icon="faHeadSideGear"
          class="fa-fw co-display-10 size-5 pr-1"
        />
      </template>
      <template #heading5Left>
        チャットサポート、課題提出、カリキュラム閲覧
      </template>
      <template #descriptionLeft>
        チャットサポート、課題提出、カリキュラム閲覧は、受講期間内でいつでもご利用いただけます。並行して学習を進めて頂いても、片方のコースから学習をされても構いません。
      </template>
      <template #heading5Right>
        メンタリング
      </template>
      <template #descriptionRight>
        パーソナルメンターとのメンタリングは決められた日程で行います。Pythonコースを前半に、AIコースを後半に行います。
      </template>
    </TeSetStudySchedule>

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-second" /> -->

    <TeCommonCampaign
      :course-name-path="packScreenName"
      :current-promotion="currentPromotion"
    />

    <!-- 料金プラン -->
    <section
      id="price"
      class="co-bg-striped"
    >
      <!-- 無料相談割引コード -->
      <TeCommonBannerTimeLimitCpnCode
        v-if="BannerNameForShowing === 'campaign'"
        :entry-campaign="entryCampaign"
      />

      <div class="co-container-lg px-5 py-20 xl:px-0">
        <h2 class="co-heading-2">
          料金
        </h2>

        <TeCommonPriceTimeLimit
          v-if="BannerNameForShowing === 'discount'"
          :entry-discount-time-limit="entryDiscountTimeLimit"
        />

        <TeSetPriceTable
          :pack="pack"
          :current-promotion="currentPromotion"
        />

        <TeSetPriceInstallments
          :pack="pack"
          :week8="true"
        />

        <!-- 早めの申し込み・入金がお得！バナー -->
        <TeCommonPricePreviously />

        <TeCommonPriceParticipationconditions />

        <div class="flex flex-col lg:flex-row">
          <TeCommonPricePrecautions />
          <TeCommonPriceCancelPolicy />
        </div>
      </div>
    </section>


    <!-- 先割 -->
    <TeSetSakiwari :pack="pack" />

    <!-- トモ割 -->
    <TeCommonTomowari
      :set="true"
    />

    <!-- キャリアアップ支援事業 -->
    <TeCommonCareerUp
      :pack="pack"
      :set16weeks="true"
    />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-third" /> -->

    <!-- キャリアサポート -->
    <TeCommonCareerSupport />

    <TeCommonComparisonSchool :benefits="true" />

    <!-- 受講の流れ -->
    <section
      id="flow"
      class="co-bg-striped"
    >
      <div class="co-container-sm mx-auto px-4 py-20 md:w-3/4 lg:w-1/2">
        <h2 class="co-heading-2">
          受講の流れ
        </h2>
        <TeSetFlow :arrow="true">
          <template #cardHeader>
            お申し込み、お支払い、アカウント発行
          </template>
          <template #cardBody>
            下記フォームより必要事項を記入してお申し込みください。お申し込み後、入金についてのご連絡させていただきます。入金が確認出来次第、アカウントを発行いたしますのでカリキュラムで予習を始めることができます。
          </template>
        </TeSetFlow>
        <TeSetFlow :arrow="true">
          <template #cardHeader>
            学習開始
          </template>
          <template #cardBody>
            開始日からはメンターによるサポートが始まります。オンライン上で学習、課題作成、チャットでの質問、パーソナルメンターとのメンタリングを繰り返し行って、短期間での習得を目指します。
          </template>
        </TeSetFlow>
        <TeSetFlow :arrow="true">
          <template #cardHeader>
            Pythonを学習
          </template>
          <template #cardBody>
            まず前半でPythonについて学習していただきます。Pythonの基礎を習得してから、機械学習プログラムの開発も行います。
          </template>
        </TeSetFlow>
        <TeSetFlow>
          <template #cardHeader>
            機械学習・ディープラーニングを実践的に習得
          </template>
          <template #cardBody>
            4種類のPythonのライブラリを使い、AI（人工知能）の構築に必要な機械学習・ディープラーニングを実践的に学びます。
          </template>
        </TeSetFlow>
      </div>
    </section>

    <!-- FAQ -->
    <!-- 251202導線削除 -->
    <!-- <section
      id="faq"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 py-20">
        <h2 class="co-display-7 mb-[3.25rem] text-center">
          FAQ
        </h2>
        <div class="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-2 md:flex-row">
          <TeSetFaq>
            <template #question>
              参加に迷っているのですが…
            </template>
            <template #answer>
              <p class="mb-4">
                テックアカデミーへの参加を検討されている方向けに、プログラミング無料でプロのカウンセラーに相談できる無料相談もご用意しています。お気軽にご参加ください。
              </p>
              <a
                class="bot_open"
                href="/counseling/htmlcss-schedule"
              >無料相談の詳細はこちら</a>
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              他のスクールとの違いは？
            </template>
            <template #answer>
              他のスクールではカリキュラムに沿って学習していくだけですが、テックアカデミーではプロを育てるため、オリジナルサービスを開発できるレベルまでパーソナルメンターが手厚くサポートし、受講生の結果にコミットしている部分が大きく違います。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              合計どのくらい学習時間が必要ですか？
            </template>
            <template #answer>
              現在の理解度のレベルと進捗スピードによって異なりますが、目安として合計300時間ほどの確保をお願いしております。無駄を省いた学習システムと、メンターへの質問・課題レビューで通常より短期間で成長することが可能です。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              期間内に学習が終わらなかったらどうなりますか？
            </template>
            <template #answer>
              受講終了後もカリキュラムは継続して閲覧が可能です。受講生様のオリジナルサービスの開発を出来る限りサポートとするため、追加のメンターサポート（4週間：97,900円［税込］／1コースにつき）も合わせてご用意しております。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              全くの初心者ですが問題ありませんか？
            </template>
            <template #answer>
              問題ありません。初心者の方でも現役のプロのメンターが全力で学習をサポートします。ただし、PCの基本的な操作が問題なくでき、期間内に必要な学習時間を確保できることが前提です。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              プランの違いはなんですか？
            </template>
            <template #answer>
              期間の違いです。300時間の学習時間を確保できるプランをお選びください。カリキュラムやメンターサポートに違いはありません。期間中に終わらない場合の追加メンターサポートもございますが、8週間プラン終了後に4週間追加するより12週間プランをお選びいただく方がお得です。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              領収書や請求書の発行はできますか？
            </template>
            <template #answer>
              可能です。領収書はお支払い後に発行方法をご案内します。また、法人からお申し込みの場合は請求書払いも対応しています。まずはご受講される方の名前でお申し込みいただき、指定のフォームからご申請ください。
            </template>
          </TeSetFaq>
        </div>
      </div>
    </section> -->

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeSetApply
      :pack="pack"
      :pack-plans="packPlans"
      :current-promotion="currentPromotion"
      :pack-screen-name="packScreenName"
      :entry-campaign="entryCampaign"
    />

    <!-- 下部固定ボタン -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

import { AdItems } from '~/utility/constants/ad_items'

import TeSetPythonAiCover from '~/components/Te/TeSet/PythonAi/TeSetPythonAiCover.vue'
import TeCommonPagenav from '~/components/Te/TeCommon/Pagenav/TeCommonPagenav.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeCommonBannerCampaign from '~/components/Te/TeCommon/Banner/TeCommonBannerCampaign/TeCommonBannerCampaign.vue'
import TeSetAbout from '~/components/Te/TeSet/TeSetAbout.vue'
import TeSetTarget from '~/components/Te/TeSet/TeSetTarget.vue'
import TeCommonDemographics from '~/components/Te/TeCommon/TeCommonDemographics/TeCommonDemographics.vue'
import TeSetOutputLeftPython from '~/components/Te/TeSet/Output/TeSetOutputLeftPython.vue'
import TeSetOutputRigthtAi from '~/components/Te/TeSet/Output/TeSetOutputRigthtAi.vue'
import TeSetSkill from '~/components/Te/TeSet/TeSetSkill.vue'
import TeCommonComparisonAiDatascience from '~/components/Te/TeCommon/Comparison/TeCommonComparisonAiDatascience/TeCommonComparisonAiDatascience.vue'
import TeCommonBannerFreeTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerFreeTrial/TeCommonBannerFreeTrial.vue'
import TeCommonMentorSupportMentoring from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportMentoring/TeCommonMentorSupportMentoring.vue'
import TeCommonMentorSupportChatSupport from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportChatSupport/TeCommonMentorSupportChatSupport.vue'
import TeCommonMentorSupportIssueReview from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportIssueReview/TeCommonMentorSupportIssueReview.vue'
import TeCommonMentorSupportMentor from '~/components/Te/TeCommon/MentorSupportMentor/TeCommonMentorSupportMentor.vue'
import TeCommonMentorSupportReason from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportReason/TeCommonMentorSupportReason.vue'
import TeSetStudySchedule from '~/components/Te/TeSet/TeSetStudySchedule.vue'
import TeCommonCampaign from '~/components/Te/TeCommon/TeCommonCampaign/TeCommonCampaign.vue'
import TeCommonPriceTimeLimit from '~/components/Te/TeCommon/Price/TeCommonPriceTimeLimit/TeCommonPriceTimeLimit.vue'
import TeSetPriceTable from '~/components/Te/TeSet/TeSetPriceTable.vue'
import TeSetPriceInstallments from '~/components/Te/TeSet/TeSetPriceInstallments.vue'
import TeCommonPricePreviously from '~/components/Te/TeCommon/Price/TeCommonPricePreviously/TeCommonPricePreviously.vue'
import TeCommonPriceParticipationconditions from '~/components/Te/TeCommon/Price/TeCommonPriceParticipationconditions/TeCommonPriceParticipationconditions.vue'
import TeCommonPricePrecautions from '~/components/Te/TeCommon/Price/TeCommonPricePrecautions/TeCommonPricePrecautions.vue'
import TeCommonPriceCancelPolicy from '~/components/Te/TeCommon/Price/TeCommonPriceCancelPolicy/TeCommonPriceCancelPolicy.vue'
import TeSetSakiwari from '~/components/Te/TeSet/TeSetSakiwari.vue'
import TeCommonTomowari from '~/components/Te/TeCommon/Tomowari/TeCommonTomowari.vue'
import TeCommonCareerUp from '~/components/Te/TeCommon/CareerUp/TeCommonCareerUp.vue'
import TeCommonCareerSupport from '~/components/Te/TeCommon/TeCommonCareerSupport/TeCommonCareerSupport.vue'
import TeCommonComparisonSchool from '~/components/Te/TeCommon/Comparison/TeCommonComparisonSchool/TeCommonComparisonSchool.vue'
import TeSetFlow from '~/components/Te/TeSet/TeSetFlow.vue'
import TeSetFaq from '~/components/Te/TeSet/TeSetFaq.vue'
import TeSetApply from '~/components/Te/TeSet/TeSetApply.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHeadSideGear, faSuitcase } from '@awesome.me/kit-65d95819ce/icons/classic/solid'
import { faPython } from '@awesome.me/kit-65d95819ce/icons/classic/brands'
import { faKeyboard, faClockNine } from '@awesome.me/kit-65d95819ce/icons/classic/regular'

const options = {
  async setup() {
    const route = useRoute()
    const namePath = route.path.split('/')[2]
    const packScreenName = `${namePath}-set`
    const { pack, packPlans } = usePack(packScreenName)
    const {
      entryDiscountTimeLimit,
      entrySettlementTimeLimit,
      entryPaymentUrl,
      entryCampaign,
      BannerNameForShowing,
    } = useTopTimeLimits()
    const { currentPromotion } = usePromotion()

    return {
      route,
      pack,
      packPlans,
      namePath,
      packScreenName,
      entryDiscountTimeLimit,
      entrySettlementTimeLimit,
      entryPaymentUrl,
      entryCampaign,
      BannerNameForShowing,
      currentPromotion,
      faHeadSideGear,
      faPython,
      faSuitcase,
      faKeyboard,
      faClockNine,
    }
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'set',
      deviceSize: useNuxtApp().$deviceSize,
      karteElement: {
        ad_item_id: AdItems[this.packScreenName].item_id,
        ad_item_price: AdItems[this.packScreenName].price,
      },
    })
    return {
      title: 'Python＋AIセット | テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              'PythonコースとAIコースをお得に受講できるセット。現役エンジニアのパーソナルメンターが毎日の学習をサポート。週に2回のマンツーマンメンタリング、毎日のチャットでサポート。',
            twitterTitle: 'Python＋AIセット',
            twitterDescription:
              'PythonコースとAIコースをお得に受講できるセット。現役エンジニアのパーソナルメンターが毎日の学習をサポート。週に2回のマンツーマンメンタリング、毎日のチャットでサポート。',
            twitterImage: '/_nuxt/ogp/og-image-python-ai-set.jpg',
            ogTitle: 'Python＋AIセット',
            ogDescription:
              'PythonコースとAIコースをお得に受講できるセット。現役エンジニアのパーソナルメンターが毎日の学習をサポート。週に2回のマンツーマンメンタリング、毎日のチャットでサポート。',
            ogUrl: '/set/python-ai',
            ogImage: '/_nuxt/ogp/og-image-python-ai-set.jpg',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  data() {
    return {
      scriptInfo: {},
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      firstOpenedWholeCohort: null,
    }
  },
  computed: {
  },
  methods: {},
  components: {
    TeSetPythonAiCover,
    TeCommonPagenav,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeCommonBannerCampaign,
    TeSetAbout,
    TeSetTarget,
    TeCommonDemographics,
    TeSetOutputLeftPython,
    TeSetOutputRigthtAi,
    TeSetSkill,
    TeCommonComparisonAiDatascience,
    TeCommonBannerFreeTrial,
    TeCommonMentorSupportMentoring,
    TeCommonMentorSupportChatSupport,
    TeCommonMentorSupportIssueReview,
    TeCommonMentorSupportMentor,
    TeCommonMentorSupportReason,
    TeSetStudySchedule,
    TeCommonCampaign,
    TeCommonPriceTimeLimit,
    TeSetPriceTable,
    TeSetPriceInstallments,
    TeCommonPricePreviously,
    TeCommonPriceParticipationconditions,
    TeCommonPricePrecautions,
    TeCommonPriceCancelPolicy,
    TeSetSakiwari,
    TeCommonTomowari,
    TeCommonCareerUp,
    TeCommonCareerSupport,
    TeCommonComparisonSchool,
    TeSetFlow,
    TeSetFaq,
    TeSetApply,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
